import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import Loader from "./Loader";
import Message from "./Message";
import React, { useState } from "react";
import ImageDialog from "./ImageDialog";

const RingSizeDialog = ({ isOpen, onClose, loadingSize, errorSize, sizes }) => {
    const [isShowMeasurement, setShowMeasurement] = useState(false);
    return (
        <div>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[10000]" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-xl transform rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-md md:text-lg font-medium leading-6 text-gray-900"
                                    >
                                        Ring Size Chart (Indian Size)
                                    </Dialog.Title>
                                    <div className="w-full h-auto pt-2">
                                        <div className="mt-2 max-h-[60vh] overflow-y-auto">
                                            <table className="w-full border-collapse border border-slate-500">
                                                <caption className="underline cursor-pointer font-[700] text-[#000080] py-2 md:text-md text-lg" onClick={() => setShowMeasurement(true)}>
                                                    How to Measure Size
                                                </caption>
                                                <tr className="text-center">
                                                    <th className="w-1/3 border border-slate-600 p-1">
                                                        Size
                                                    </th>
                                                    <th className="w-2/3 border border-slate-600 p-1">
                                                        Internal Diameter(mm.)
                                                    </th>
                                                </tr>
                                                {loadingSize ? (
                                                    <Loader />
                                                ) : errorSize ? (
                                                    <Message type="error">{errorSize}</Message>
                                                ) : (
                                                    sizes?.map((size) => (
                                                        <tr className="text-center">
                                                            <td className="border border-slate-700 p-1">
                                                                {size?.size}
                                                            </td>
                                                            <td className="border border-slate-700 p-1">
                                                                {size?.internalDiameterMM} mm.
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </table>
                                        </div>
                                    </div>
                                    <div className="mt-4 text-right">
                                        <button
                                            className="inline-flex justify-center rounded-md bg-blue-500 px-4 py-2 text-sm text-white hover:bg-blue-600"
                                            onClick={onClose}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
            {/* Show */}
            <ImageDialog
                isOpen={isShowMeasurement}
                onClose={() => setShowMeasurement(false)}
                imageUrl={'/ringGuid.jpg'}
            />
        </div>
    )
}

export default RingSizeDialog
